import React, { useMemo } from "react"
import { Tabs, Card, Typography, Flex, Space } from "antd"
import Breadcrumb from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { notification } from "antd"
import Work from "./work"
import QuotaBurn from "./quota-burn"
import QuotaBurnCancel from "./quota-burn-cancel"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { getCurrentUser } from "helpers/service_helper"
import {
  CalculatorOutlined,
  MinusCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,
} from "@ant-design/icons"

const { Title, Text } = Typography

notification.config({
  duration: 1,
  rtl: true,
})

const Index = props => {
  const { t, openNotification, matches_sm } = props
  
  const tabItems = useMemo(() => {
    const items = [
      {
        key: "1",
        label: (
          <Space>
            <CalculatorOutlined />
            {!matches_sm && "کارکرد مهندسین"}
            {matches_sm && "کارکرد"}
          </Space>
        ),
        children: <Work openNotification={openNotification} matches_sm={matches_sm} />,
      },
    ]
    
    if (getCurrentUser().role === "Administrator") {
      items.push(
        {
          key: "2",
          label: (
            <Space>
              <MinusCircleOutlined />
              {!matches_sm && "کسر سهمیه ها"}
              {matches_sm && "کسر"}
            </Space>
          ),
          children: <QuotaBurn openNotification={openNotification} />,
        },
        {
          key: "3",
          label: (
            <Space>
              <CloseCircleOutlined />
              {!matches_sm && "کسر کنسلی سهمیه ها"}
              {matches_sm && "کنسلی"}
            </Space>
          ),
          children: <QuotaBurnCancel openNotification={openNotification} />,
        }
      )
    }
    
    return items
  }, [openNotification, matches_sm])

  return (
    <>
      <MetaTags>
        <title>کارکرد مهندسین | واحد گاز</title>
      </MetaTags>

      {/* Header */}
      <Card
        size="small"
        style={{
          marginBottom: 16,
          borderRadius: 12,
          border: "none",
          background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
          boxShadow: "0 4px 15px rgba(82, 196, 26, 0.3)",
        }}
        styles={{ body: { padding: matches_sm ? 12 : 16 } }}
      >
        <Flex justify="space-between" align="center" wrap="wrap" gap={12}>
          <Flex align="center" gap={10}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TeamOutlined style={{ fontSize: 20, color: "#fff" }} />
            </div>
            <div>
              <Title
                level={5}
                style={{
                  margin: 0,
                  color: "#fff",
                  fontSize: matches_sm ? 14 : 16,
                }}
              >
                کارکرد مهندسین
              </Title>
              <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: 11 }}>
                مدیریت سهمیه و کارکرد
              </Text>
            </div>
          </Flex>
        </Flex>
      </Card>

      {/* Tabs */}
      <Card
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        styles={{ body: { padding: matches_sm ? 8 : 16 } }}
      >
        <Tabs
          destroyInactiveTabPane={true}
          tabBarGutter={matches_sm ? 8 : 16}
          items={tabItems}
          size={matches_sm ? "small" : "middle"}
          type="card"
        />
      </Card>
    </>
  )
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Index))
